import React from 'react'
import RootComponent from './RootComponent'

export default function RootSearchPageComponent ({ data, searchQuery, searchResults, searchCategories, header, footer, context, location }) {
  data.SearchResults = searchResults
  data.SearchQuery = searchQuery
  data.SearchCategories = searchCategories
  return <RootComponent {...{ data, header, footer, context, location }} />
}
